import { apiRequest } from './client';
import { env } from '../config/env';

const ENDPOINT = '/debug-controller-4719';

export async function fetchPublicSystemStatus(options = {}) {
  const response = await fetch(`${env.apiBaseUrl}${ENDPOINT}`, {
    headers: { 'Content-Type': 'application/json' },
    signal: options.signal,
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || 'Unable to load system status.');
  }

  return payload;
}

export async function fetchDebugControllerSnapshot(token) {
  return apiRequest(`${ENDPOINT}?detail=1`, token);
}

export async function setDebugSiteMode(token, { mode, message = '' }) {
  return apiRequest(ENDPOINT, token, {
    method: 'POST',
    body: JSON.stringify({
      action: 'set_mode',
      mode,
      message,
    }),
  });
}

export async function wipeDebugTable(token, table) {
  return apiRequest(ENDPOINT, token, {
    method: 'POST',
    body: JSON.stringify({
      action: 'wipe_table',
      table,
    }),
  });
}

export async function wipeAllDebugData(token) {
  return apiRequest(ENDPOINT, token, {
    method: 'POST',
    body: JSON.stringify({
      action: 'wipe_all',
      confirm: 'WIPE ALL',
    }),
  });
}

export async function wipeAuthDebugTable(token, table, password) {
  return apiRequest(ENDPOINT, token, {
    method: 'POST',
    body: JSON.stringify({
      action: 'wipe_auth_table',
      table,
      password,
    }),
  });
}

export async function setBlockedPages(token, pages) {
  return apiRequest(ENDPOINT, token, {
    method: 'POST',
    body: JSON.stringify({
      action: 'set_blocked_pages',
      pages,
    }),
  });
}

export async function fetchHawbCronDebugSnapshot(token) {
  return apiRequest(`${ENDPOINT}/hawb-cron`, token);
}

export async function runHawbCronNow(token) {
  return apiRequest(`${ENDPOINT}/hawb-cron`, token, {
    method: 'POST',
    body: JSON.stringify({ action: 'run_now' }),
  });
}
